angular
	.module 'App.Repository'
	.factory 'ShippingMethodDataProviderRepository', ['BaseRepository', (BaseRepository) ->
		class ShippingMethodDataProviderRepository extends BaseRepository
			@resource = '/shipping_method_data_providers'
			@isRestricted = true

		return new ShippingMethodDataProviderRepository
	]
